import React from "react";
import PolicyLayout, { Section, PolicyList } from "../../components/storefront/PolicyLayout";

export default function WarrantyPolicy() {
  return (
    <PolicyLayout
      testid="warranty-policy-page"
      heading="Warranty Policy"
      title="Warranty Policy | Lecis Auto Glass"
      description="Lecis Auto Glass warranty policy — coverage for side mirrors, windshields and backglass, OEM-style vs aftermarket products, exclusions and the warranty claim process."
      canonicalPath="/warranty-policy"
      updated="June 2026"
    >
      <Section>
        <p>
          Lecis Auto Glass stands behind the quality of the auto glass and mirror products we sell. This
          policy describes what is covered, what is excluded, and how to submit a warranty claim.
        </p>
      </Section>

      <Section title="What Products Are Covered">
        <p>
          Our warranty covers <strong className="text-zinc-100">manufacturing defects in materials and
          workmanship</strong> on side mirrors, windshields and backglass sold by Lecis Auto Glass, for the
          warranty period applicable to the product. Coverage applies to the original purchaser with valid
          proof of purchase.
        </p>
      </Section>

      <Section title="OEM-Style vs Aftermarket Products">
        <PolicyList
          items={[
            "We offer both OEM-style and aftermarket products; the fitment type is indicated on each product page.",
            "OEM-style products are designed to match original equipment form, fit and function.",
            "Aftermarket products are quality alternatives that may vary slightly from original equipment while meeting applicable fitment specifications.",
            "Warranty coverage applies to defects in the product as sold, regardless of type. It does not guarantee compatibility if fitment was not confirmed prior to purchase.",
          ]}
        />
      </Section>

      <Section title="Warranty Exclusions">
        <p>The warranty does not cover:</p>
        <PolicyList
          items={[
            "Damage from improper installation, accidents, misuse, abuse, or normal wear and tear.",
            "Damage occurring after delivery, including chips, cracks, or scratches from road debris or handling.",
            "Products modified, altered, or installed contrary to manufacturer guidelines.",
            "Shipping damage (covered separately under our Shipping Policy).",
            "Labor, installation, calibration, or any incidental or consequential costs.",
            "Fitment issues where the customer did not confirm compatibility before purchase.",
          ]}
        />
      </Section>

      <Section title="Warranty Claim Process">
        <PolicyList
          items={[
            "Contact us at support@lecisautoglass.com with your order number and a description of the defect.",
            "Include clear photos (and video where helpful) showing the defect.",
            "Our team will review the claim and may request additional information.",
            "If approved, we will provide a replacement or a refund for the defective product at our discretion.",
            "We recommend that all products be installed by a qualified professional to preserve warranty eligibility.",
          ]}
        />
      </Section>
    </PolicyLayout>
  );
}
